import * as React from 'react';
import { CodeBlock } from '../../cookbook-ui/custom-components/CodeBlock/CodeBlock';
import { AlertInlineMain } from '@inmoment/the-kitchen';

export interface Props {}

export const DrawerDocumentation: React.FC<Props> = (props) => {
  return (
    <div>
      <AlertInlineMain
        title="Drawer Slots"
        subtitle="In order for this component to function properly, in React and Web Components, the slot syntax needs to be followed. See the code snippets
            above for example implementation."
        color="admin"
      />
      <br />

      <CodeBlock
        hasTopRadius={false}
        code={`Slot areas on the Drawer Component


  slot="title"
  slot="menu"
  slot="body"
  slot="footer"`}
      />

      <br />
    </div>
  );
};
